export const cacheKey = "/apps/user_recent_event_history/:user_identifier";
